import { ApiProductType, SapiPlanType, SapicConnectivity } from '@app-types/api';
import { PRICE_TYPE } from '@app-types/price';
import { Connectivity, ObligationType, PlanType, Product, ProductNeedElement, ProductTypeId } from '@app-types/product';

export class SapiMapper {
    static mapToProduct(apiData: ApiProductType): Product {
        return {
            gencode: apiData.gencode,
            typeId: apiData.type_id,
            name: apiData.name,
            price: apiData.price,
            prices: {
                // use for sapic
                initial: apiData.price,
                forever: apiData.price,
                final: apiData.price,
                type:
                    (apiData.type_id === ProductTypeId.FAI_FMD || apiData.type_id === ProductTypeId.SIM) &&
                    !!apiData.price_type
                        ? PRICE_TYPE.DEFERRED
                        : PRICE_TYPE.TODAY,
            },
            products: [],
            inStock: apiData.in_stock,
            categories: apiData.categories || [],
            neededElements: apiData.to_add_front ? (JSON.parse(apiData.to_add_front) as ProductNeedElement[]) : [],
            discounts: [], // only for sapic product
        };
    }

    static mapToPlan(apiData: SapiPlanType): PlanType {
        return {
            categories: [],
            dataSize: 0,
            discounts: [],
            // image: '',
            inStock: false,
            newprice: 0,
            options: [],
            position: 0,
            products: [],
            typeId: apiData.type_id,
            gencode: apiData.gencode,
            price: apiData.price,
            obligation: apiData.obligation || ObligationType.NONE,
            obligationLabel: SapiMapper.getObligationLabel(apiData.obligation),
            name: apiData.name.replace('Avantages Smartphone', ''),
            dataEnvelope: apiData.data_envelope || '',
            connectivity: SapiMapper.mapSapiConnectivityToConnectivity(apiData.max_connection),
            roamingEnvelope: apiData.roaming_envelope,
            commercialRange: apiData.commercial_range,
            fromAbroad: apiData.from_abroad,
            smsMms: apiData.sms_mms,
            prices: {
                initial: apiData.price,
                forever: apiData.price,
                final: apiData.price,
            },
            option5g: undefined,
            optionByouMax: undefined,
        };
    }

    static getObligationLabel(obligation?: ObligationType) {
        switch (obligation) {
            case ObligationType.MONTHLY_24:
                return 'engagement 24 mois';
            case ObligationType.MONTHLY_12:
                return 'engagement 12 mois';
            default:
                return 'sans engagement';
        }
    }

    static mapSapiConnectivityToConnectivity(connectivity: SapicConnectivity | undefined): Connectivity | undefined {
        switch (connectivity) {
            case SapicConnectivity.FIVE_G:
                return Connectivity.FIVE_G;
            case SapicConnectivity.FOUR_G_PLUS:
                return Connectivity.FOUR_G_PLUS;
            default:
                return Connectivity.FOUR_G;
        }
    }
}
